import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { formatDate } from '@angular/common';
import { DateFormatService } from '../ngx-datetime-formats.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'formly-datetimepicker',
  templateUrl: './date-time-picker.html',
  styleUrls: ['./date-time-picker.scss'],
  encapsulation: ViewEncapsulation.None
})
// tslint:disable-next-line:component-class-suffix
export class DatetimepickerFieldType extends FieldType implements OnInit {

  constructor(private dateFormatService: DateFormatService) {
    super();
  }

  ngOnInit(): void {
    this.field.templateOptions.hideTime = this.field.templateOptions.hideTime || false;
    this.field.templateOptions.ignoreSeconds = this.field.templateOptions.ignoreSeconds || false;
    if (this.field?.templateOptions?.hideTime) {
      this.dateFormatService.setDateFormat("MM/DD/yyyy")
    } else {
      this.dateFormatService.setDateFormat("MM/DD/yyyy hh:mm:ss A")
    }
    this.SubscribeOnChanged();

  }
  public SubscribeOnChanged() {
    this.field.formControl.valueChanges.subscribe((val: Date) => {
      let value = val;
      if (this.field?.templateOptions?.hideTime && value) {

        this.field.formControl.setValue(value);
      }

      if (this.field.templateOptions.ignoreSeconds) {
        if (value) {
          if (typeof (value as any).toDate === 'function') {
            value = (value as any).toDate();
          }

          if (!(value instanceof Date)) {
            value = new Date(value);
          }

          value.setSeconds(0, 0);

          const currentTime = this.field.formControl.value ? new Date(this.field.formControl.value).getTime() : null;
          if (value.getTime() !== currentTime) {
            this.field.formControl.setValue(value, { emitEvent: false });
          }
        }
      }

      this.field.formControl.markAsTouched();
    });
  }

  returnDate() {
    try {
      const value = this.field.formControl.value;
      if (!value) {
        return ''; // Return an empty string if the value is null, undefined, or falsy
      }
      const date = new Date(value);
      if (this.field?.templateOptions?.hideTime) {
        return formatDate(date, 'MM/dd/yyyy', "en-US");
      } else {
        return formatDate(date, 'MM/dd/yyyy hh:mm:ss', "en-US");
      }
    } catch (e) {
      return '';
    }
  }
}
